if (!customElements.get('card-variant-add')) {
  customElements.define(
    'card-variant-add',
    class CardVariantAdd extends HTMLElement {
      connectedCallback() {
        this.form = this.querySelector('form');
        this.picker = this.querySelector('[data-variant-picker]');
        this.variantInput = this.querySelector('[name="id"]');
        this.optionButtons = this.querySelectorAll('[data-variant-option]');

        if (!this.form) return;

        this.selectedVariantId = '';
        this.onSubmit = this.onSubmit.bind(this);
        this.onDocumentClick = this.onDocumentClick.bind(this);
        this.onOptionClick = this.onOptionClick.bind(this);

        this.form.addEventListener('submit', this.onSubmit, true);
        this.optionButtons.forEach((button) => {
          button.addEventListener('click', this.onOptionClick);
        });
      }

      disconnectedCallback() {
        if (this.form) {
          this.form.removeEventListener('submit', this.onSubmit, true);
        }
        this.optionButtons.forEach((button) => {
          button.removeEventListener('click', this.onOptionClick);
        });
        document.removeEventListener('click', this.onDocumentClick);
      }

      onSubmit(event) {
        if (!this.picker) return;

        if (this.addingFromOption) {
          this.addingFromOption = false;
          this.variantInput.value = this.selectedVariantId;
          this.variantInput.disabled = false;
          return;
        }

        event.preventDefault();
        event.stopImmediatePropagation();

        if (this.picker.hidden) {
          this.openPicker();
          return;
        }

        this.closePicker();
      }

      onOptionClick(event) {
        const button = event.currentTarget;
        if (button.disabled || !button.dataset.variantId) return;

        this.selectedVariantId = button.dataset.variantId;
        this.variantInput.value = this.selectedVariantId;
        this.variantInput.disabled = false;
        this.picker.classList.remove('is-invalid');
        this.addingFromOption = true;

        this.optionButtons.forEach((option) => {
          option.classList.toggle('is-selected', option === button);
        });

        this.form.requestSubmit();
      }

      openPicker() {
        document.querySelectorAll('card-variant-add.is-open').forEach((element) => {
          if (element !== this) element.closePicker();
        });

        this.picker.hidden = false;
        this.classList.add('is-open');

        const firstAvailable = this.querySelector('[data-variant-option]:not([disabled])');
        if (firstAvailable) firstAvailable.focus();

        window.setTimeout(() => {
          document.addEventListener('click', this.onDocumentClick);
        });
      }

      closePicker() {
        if (!this.picker) return;
        this.picker.hidden = true;
        this.picker.classList.remove('is-invalid');
        this.classList.remove('is-open');
        document.removeEventListener('click', this.onDocumentClick);
      }

      onDocumentClick(event) {
        if (!this.contains(event.target)) {
          this.closePicker();
        }
      }
    }
  );
}
